var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/favorite-chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "favorite-chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4167 10.2917V7.12501C17.4167 3.16668 15.8334 1.58334 11.875 1.58334H7.12504C3.16671 1.58334 1.58337 3.16668 1.58337 7.12501V11.875C1.58337 15.8333 3.16671 17.4167 7.12504 17.4167H10.2917",
    stroke: "#101513",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.80286 11.4713L7.68703 9.025C7.95619 8.67666 8.45495 8.61334 8.80328 8.8825L10.252 10.0225C10.6004 10.2917 11.0991 10.2283 11.3683 9.88792L13.197 7.52875",
    stroke: "#101513",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.4217 12.5242L15.6433 12.9754C15.7542 13.1971 16.0313 13.4029 16.2767 13.4504L16.5775 13.4979C17.48 13.6483 17.6938 14.3133 17.0446 14.9704L16.7675 15.2475C16.5854 15.4375 16.4825 15.8017 16.5379 16.055L16.5775 16.2213C16.8229 17.3138 16.245 17.7333 15.295 17.1633L15.0892 17.0446C14.8438 16.9021 14.4479 16.9021 14.2025 17.0446L13.9967 17.1633C13.0387 17.7412 12.4608 17.3138 12.7142 16.2213L12.7537 16.055C12.8092 15.8017 12.7063 15.4375 12.5242 15.2475L12.2471 14.9704C11.5979 14.3133 11.8117 13.6483 12.7142 13.4979L13.015 13.4504C13.2525 13.4108 13.5375 13.1971 13.6483 12.9754L13.87 12.5242C14.2975 11.6613 14.9942 11.6613 15.4217 12.5242Z",
    stroke: "#101513",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetIcon);
export default __webpack_public_path__ + "static/media/bet-icon.c6c9230e57dff03f4856585992c10f64.svg";
export { ForwardRef as ReactComponent };